var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBase64)?_c('img',{staticClass:"responsive",class:_vm.customClass,attrs:{"src":_vm.document,"alt":"img"}}):_c('img',{staticClass:"responsive",class:_vm.customClass,attrs:{"src":_vm.temporaryLinkUri,"alt":"img"}})
}
var staticRenderFns = []

export { render, staticRenderFns }